module.exports = __webpack_public_path__ + "aaeddd330a9f3f15dfb03e363790b014.png";